import { setSpecificMessage, digits } from "valibot";
setSpecificMessage(
  digits,
  (issue) => `Chiffres invalide: reçu ${issue.received}`,
  "fr"
);